import qs from 'qs';
import { get } from './';

// Public (unauthenticated) travel diary endpoints, addressed by the trip's
// share token (KD-3503).
export const getSharedTravelDiary = ({ shareToken }) => {
  return get(`/api/internal/travel-diaries/${shareToken}`);
};

export const getSharedTravelDiarySettings = shareToken => {
  return ({ filters, skip } = {}) => {
    if (skip) {
      return Promise.resolve(null);
    }
    return get(
      `/api/internal/travel-diaries/${shareToken}/settings?${qs.stringify(filters)}`,
    );
  };
};

export const getSharedHotel = ({ shareToken, hotelId, locale }) => {
  if (!hotelId) {
    return Promise.resolve(null);
  }
  return get(
    `/api/internal/travel-diaries/${shareToken}/hotels/${hotelId}?locale=${locale ?? 'en'}`,
  );
};

export const getSharedAccommodationLabels = ({ shareToken, locale }) => {
  return get(
    `/api/internal/travel-diaries/${shareToken}/accommodation-labels?locale=${locale ?? 'en'}`,
  );
};

export const getSharedTravelDiaryContents = ({ shareToken, locale }) => {
  return get(
    `/api/internal/travel-diaries/${shareToken}/contents?${qs.stringify({ locale })}`,
  );
};

export const getSharedPricingSummary = shareToken => {
  return () =>
    get(`/api/internal/travel-diaries/${shareToken}/pricing-summary`);
};

export const getSharedOrganizationTheme = shareToken => {
  return () => get(`/api/internal/travel-diaries/${shareToken}/theme`);
};
